import Button from '@pelckmans/elementis/components/button';
import PinIcon from '@pelckmans/elementis/icons/pin';
import ShareIcon from '@pelckmans/elementis/icons/share';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import SelectionContext from '../_contexts/SelectionContext';

const BASE = 'PAGES.TOC_LEVEL.BULK_BAR';

export default function BulkBar() {
  const { t } = useTranslation();
  const { countSelection, clearSelection } = useContext(SelectionContext);

  if (countSelection() === 0) return null;

  return (
    <dialog className="bulk-bar" aria-label={t(`${BASE}.A11Y_LABEL`)} open>
      <div className="bulk-bar__selected">
        {t(`${BASE}.MESSAGE`, { amount: countSelection() })}
        <Button size="sm" prominence="ghost" onClick={clearSelection}>
          {t(`${BASE}.ACTIONS.CLEAR.LABEL`)}
        </Button>
      </div>
      <div className="bulk-bar__button-group">
        <Button size="sm" startIcon={<PinIcon />}>
          {t(`${BASE}.ACTIONS.PIN.LABEL`)}
        </Button>
        <Button size="sm" startIcon={<ShareIcon />}>
          {t(`${BASE}.ACTIONS.SHARE.LABEL`)}
        </Button>
      </div>
    </dialog>
  );
}
